import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";
import Image from "next/image";
import Magnifier from "assets/svg/magnifier.svg";
import { IoMdSearch } from "react-icons/io";
import Search from "assets/svg/tableSearch.svg";
type PropsType = {
  filter: any;
  setFilter: any;
  i18n: any;
};
const GlobalFilter: React.FC<PropsType> = ({ filter, setFilter, i18n }) => {
  const [show, setShow] = useState(false);
  //   const onChanges = useAsyncDebounce((value: any) => {
  //     setFilter(value || undefined);
  //   }, 300);
  /* const returnCorrectLeft = (): string => {
    if (i18n.language === "ar") {
      return "-translate-x-full";
    } else {
      return "translate-x-full";
    }
  }; */
  return (
    <div className="overflow-hidden z-0">
      <div className=" flex items-center gap-2 bg-white p-1 px-2 rounded-md ">
        <div
          /*  onClick={() => setShow(!show)} */
          className=""
        >
          <Image src={Search} alt="img"/>
        </div>
        <input
          value={filter || ""}
          placeholder={i18n.t("search")}
          onChange={(e) => {
            setFilter(e.target.value);
            //   onChanges(e.target.value);
          }}
          className="search w-full"
          /*  className={`transform relative rounded-lg transition outline-none focus:outline-none  duration-300 p-1 px-2 z-0 ${
            show ? `translate-x-0 bg-white   ` : ` ${returnCorrectLeft()}    `
          } `} */
          type="search"
        />

        {/* <Image
          src={Magnifier}
          alt="filter icon"
          width="20"
          height="23"
          layout="fixed"
        /> */}
      </div>
    </div>
  );
};
export default GlobalFilter;
